import { useMemo } from 'react';
import { useFormViewerContext } from './form-viewer-context';
export const useFormSteps = (formId) => {
    var _a, _b;
    const { controller } = useFormViewerContext();
    const form = (_b = (_a = controller.wfConfig) === null || _a === void 0 ? void 0 : _a.formsById) === null || _b === void 0 ? void 0 : _b[formId];
    return useMemo(() => {
        var _a;
        if (!form) {
            return undefined;
        }
        return (_a = ((form === null || form === void 0 ? void 0 : form.steps) || [])) === null || _a === void 0 ? void 0 : _a.filter((step) => { var _a, _b, _c; return !step.hidden && ((_c = (_b = (_a = step.layout) === null || _a === void 0 ? void 0 : _a.large) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.length); }).map((step) => ({
            id: step.id,
            name: step.name,
        }));
    }, [form]);
};
//# sourceMappingURL=use-form-steps.js.map